import React, { Component } from 'react';
import { Button, Col, Row, Modal, ModalBody } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import home_page1 from '../../../assets/img/home_img1.png';
import home_page2 from '../../../assets/img/home_img3.png';
import stage from '../../../assets/img/home_stage.png';

import html_btn_1 from '../../../assets/img/home-btn-1.png';
import html_btn_2 from '../../../assets/img/home-btn-2.png';
import html_btn_3 from '../../../assets/img/home-btn-3.png';

import html_btn_1_d from '../../../assets/img/home-btn-1-n.png';
import html_btn_2_d from '../../../assets/img/home-btn-2-n.png';
import html_btn_3_d from '../../../assets/img/home-btn-3-n.png';

import bottom_img from '../../../assets/img/home_img_bottom.png';
import bottom_img2 from '../../../assets/img/home_img_bottom2.png';

import instagram_square from '../../../assets/img/instagram-square.png';

import home_img2 from '../../../assets/img/home_img2.png';

import { LogoHeader } from '../../../containers/Components/index'

class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      signup: false,
      warning: "",
      showVerify: false,
      html_btn_status: 0,
      watchDemo: false,
      middle_btn_status: 0,
      mobile_state: false,
    };
    this.user_name = "";
    this.pwd = "";
    this.toggleLogin = this.toggleLogin.bind(this);
    this.toggleRegister = this.toggleRegister.bind(this);
    this.updateEmailInput = this.updateEmailInput.bind(this);
    this.toggleGoogleSignUp = this.toggleGoogleSignUp.bind(this);
    this.toggleSelect = this.toggleSelect.bind(this);
    this.toggleWatchDemo = this.toggleWatchDemo.bind(this);
    this.toggleMiddleBtn = this.toggleMiddleBtn.bind(this);
  }

  updateEmailInput(evt) {
    this.user_email = evt.target.value;
    this.setState({warning : "", showVerify: false});
  }

  toggleMiddleBtn(index) {
    let value = this.state.middle_btn_status;
    if (index === -5) {
      value--;
    } else if (index === 5) {
      value++;
    } else {
      value = index;
    }
    if (value < 0) {
      value = 3;
    }
    if (value > 3) {
      value = 0;
    }
    this.setState({middle_btn_status: value});
  }

  updatePwdInput(evt) {
    this.pwd = evt.target.value;
    this.setState({warning : "" , showVerify: false});
  }

  toggleFaceBookSignUp() {

  }

  toggleWatchDemo() {
    this.setState({watchDemo: !this.state.watchDemo})
  }


  toggleGoogleSignUp() {

  }

  toggleSelect(index) {
    this.setState({html_btn_status: index});
  }

  toggleLogin() {
    this.setState({login: true});
  }
  toggleRegister() {
    this.setState({signup: true});
  }
  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.signup) {
      return <Redirect to= { '/register/'} />
    }
  }
  render() {

    return (
      <div className="app flex-row position-abs font-Poppins">
      {this.renderRedirect()}
        <React.Fragment>
        <LogoHeader />

        <div className="app-body p-0 m-0  mt-5">
          <Row className=" width-100vw p-0 m-0">
            <Col md ='12' className = "p-0 m-0" >
              <img  alt="" className = "d-md-down-none width-100 p-0 m-0" src = {home_page1} /> 
              <img  alt="" className = "d-md-down-none width-100 p-0 m-0" src = {home_img2} /> 
              <img  alt="" className = "d-sm-none width-100 p-0 m-0" src = {home_page2} /> 
            </Col>
              <div className =  "w-100  margin-top-50 d-md-down-none  m-0">
                <Row className="home-top-210 home-margin-15"> 
                  <Col xs="0" sm="0" lg="6">
                    <h1 className = "font-weight-900" >Discover XR.</h1>
                    <h6>Build your experiences with AbilitàXR</h6>
                    <Button color="primary" onClick = {()=> this.toggleRegister()} className="pr-4 mt-3 mr-3 pl-4 btn-primary btn-pill home-primary-btn home-btn-min-height" >Get Started for Free</Button>
                    <Button color="primary" onClick = {() => this.toggleWatchDemo()} className="home-btn-padding home-color-play pr-4 mt-3 home-watch-demo home-border-color-watch mr-3 pl-4 btn-outline-primary btn-pill" ><i className = "home-color-play fa fa-play fa-lg" /> Watch The Film </Button>
                  </Col>
                </Row>
              </div>
          
              <Col className = " text-center pb-5 pt-3 home-background-gray 	d-block d-sm-none" xs="12" sm="12" lg="0">
                <h1 className = "font-weight-900" >Discover XR.</h1>
                <h6>Build your experience with AbilitàXR</h6>
                <Button color="primary" onClick = {()=> this.toggleRegister()} className="pr-4 mt-3 mr-3 pl-4 btn-primary btn-pill home-primary-btn home-btn-min-height" >Get Started for Free</Button>
                <Button color="primary" onClick = {() => this.toggleWatchDemo()} className="home-btn-padding home-color-play pr-4 mt-3 mr-3 home-watch-demo home-border-color-watch pl-4 btn-outline-primary btn-pill" ><i className = "home-color-play fa fa-play fa-lg" /> Watch Demo </Button>
              </Col>
              <Col md ='12' className='text-center background-gradient'>
                <h3 className = "mb-5">AbilitàXR is for every one!</h3>
                <Row className = "d-md-down-none">
                  <Col className = "text-right" xs="3" sm="3" lg="2">
                    <Button onClick={()=> this.toggleMiddleBtn(-5)} color="primary" className="btn-ghost-light home-transparant" ><h1 className = "font-size-3"><i className = "icon-arrow-left" /></h1></Button>
                  </Col>
                  <Col className = "mt-2 pt-1" xs="6" sm="6" lg="8">
                    <Row >
                      <Col className = "" xs="12" sm="12" lg="3">
                        <Button onClick={()=> this.toggleMiddleBtn(0)} color="primary" className= {this.state.middle_btn_status === 0? "btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn select-home-status btn-outline-secondary btn-block": "btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn btn-outline-secondary btn-block"}  >Real Estate</Button>
                      </Col>
                      <Col className = "" xs="12" sm="12" lg="3">
                        <Button onClick={()=> this.toggleMiddleBtn(1)} color="primary" className= {this.state.middle_btn_status === 1? "btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn select-home-status btn-outline-secondary btn-block":"btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn btn-outline-secondary btn-block"} >Architecture</Button>
                      </Col>
                      <Col className = "" xs="12" sm="12" lg="3">
                        <Button onClick={()=> this.toggleMiddleBtn(2)} color="primary" className= {this.state.middle_btn_status === 2? "btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn select-home-status btn-outline-secondary btn-block":"btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn btn-outline-secondary btn-block"} >Media</Button>
                      </Col>
                      <Col className = "" xs="12" sm="12" lg="3">
                        <Button onClick={()=> this.toggleMiddleBtn(3)} color="primary" className= {this.state.middle_btn_status === 3? "btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn select-home-status btn-outline-secondary btn-block": "btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn btn-outline-secondary btn-block"} >Training</Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col className = "text-left" xs="3" sm="3" lg="2">
                   <Button onClick={()=> this.toggleMiddleBtn(5)} color="primary" className="btn-ghost-light home-transparant" ><h1 className = "font-size-3"><i className = "icon-arrow-right" /></h1></Button>
                  </Col>
                </Row>
                <Row className = "d-sm-none">
                  <Col className = "text-right" xs="3" sm="3" lg="2">
                    <Button onClick={()=> this.toggleMiddleBtn(-5)} color="primary" className="btn-ghost-light home-transparant" ><h1 className = "font-size-3"><i className = "icon-arrow-left" /></h1></Button>
                  </Col>
                  <Col className = "mt-2 pt-1" xs="6" sm="6" lg="8">
                    <Row className = "p-0">
                      {this.state.middle_btn_status === 0? 
                      <Col className = "p-0" xs="12" sm="12" lg="3">
                        <Button  color="primary" className="btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn select-home-status btn-outline-secondary btn-block"  >Real Estate</Button>
                      </Col>:null}  
                      {this.state.middle_btn_status === 1? 
                      <Col className = "p-0" xs="12" sm="12" lg="3">
                        <Button  color="primary" className="btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn select-home-status btn-outline-secondary btn-block" >Architecture</Button>
                      </Col>: null}
                      {this.state.middle_btn_status === 2? 
                      <Col className = "p-0" xs="12" sm="12" lg="3">
                        <Button color="primary" className="btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn select-home-status btn-outline-secondary btn-block" >Media</Button>
                      </Col>: null}
                      {this.state.middle_btn_status === 3? 
                      <Col className = "p-0" xs="12" sm="12" lg="3">
                        <Button color="primary" className="btn pt-3 pb-3 pr-2 pl-2 home-transparant-btn select-home-status btn-outline-secondary btn-block" >Training</Button>
                      </Col>: null}
                    </Row>
                  </Col>
                  <Col className = "text-left" xs="3" sm="3" lg="2">
                   <Button onClick={()=> this.toggleMiddleBtn(5)} color="primary" className="btn-ghost-light home-transparant" ><h1 className = "font-size-3"><i className = "icon-arrow-right" /></h1></Button>
                  </Col>
                </Row>
                {this.state.middle_btn_status === 0? 
                  <h6 className = "mt-4"> 
                  Real estate companies see huge potential in the use of both VR and AR. While VR can serve as an alternative to open house, 
                  AR might help potential customers visualize their for-now-empty-homes with furniture and decor. 
                  <br/>
                  <br/>
                  <Button href = "/realestate" color="link" className="home-color-play mt-3 mb-5  px-0">Read More</Button>
                  </h6>: null
                }
                {this.state.middle_btn_status === 1? 
                  <h6 className = "mt-4"> Right from design mockups to walk-through, VR allows the architect to project his Building Information Module to the real 
                  estate developers in the most effective manner. 
                  <br/>
                  <br/>
                  <Button href = "/architecture" color="link" className="home-color-play mt-3 mb-5  px-0">Read More</Button>
                  </h6>: null
                }
                {this.state.middle_btn_status === 2? 
                  <h6 className = "mt-4"> For most people, the first thing that comes to mind when they hear the words “virtual reality” is entertainment. 
                  After all, a VR headset seems on the surface to be essentially a very high-tech video game. 
                  <br/>
                  <br/>
                  <Button href = "/media" color="link" className="home-color-play mt-3 mb-5  px-0">Read More</Button>
                  </h6>: null
                }
                {this.state.middle_btn_status === 3? 
                  <h6 className = "mt-4"> Corporate training is evolving, with powerful tools, such as AR and VR, becoming the norm. Both AR and VR 
                  offer employee simulations, scenarios and information in a secure, risk-free environment. 
                  <br/>
                  <br/>
                  <Button href = "/training" color="link" className="home-color-play mt-3 mb-5  px-0">Read More</Button>
                  </h6>: null
                }

                <h1 className = "mt-5 pt-5 d-md-down-none"> We have got everything for you.</h1>
                <h5 className = "d-sm-none"> We have got everything for you.</h5>
                <div className="w-100 mt-5 mb-5">
                  <img  alt="" className = "mb-5 d-md-down-none home-stage-image" src={stage} />
                  <img  alt="" className = "mb-5 d-sm-none  home-stage-image-min" src={stage} />
                </div>
                <Row className="mt-5">
                  <Col md = '3'>
                  </Col>
                  <Col md = '6'>
                    <Row className = "border-bottom text-secondary">
                      <Col className="text-center"  xs="4" sm="4" md="4" onClick = {()=> this.toggleSelect(0)}>
                       {
                        this.state.html_btn_status === 0 ? 
                        <img  alt="" src = {html_btn_1} /> :
                        <img  alt="" src = {html_btn_1_d} />
                       }
                       {
                        this.state.html_btn_status === 0 ? 
                        <h5 className = " d-md-down-none mt-4 mb-0 min-height-55 padding-bottom-12 border-bottom border-dark text-dark">Experience a new Reality</h5> :
                        <h5 className = " d-md-down-none mt-4 mb-0 min-height-55 padding-bottom-12 ">Experience a new Reality</h5>
                       }
                       {
                        this.state.html_btn_status === 0 ? 
                        <h6 className = "d-sm-none mt-4 mb-0 min-height-55 padding-bottom-12 border-bottom border-dark text-dark">Experience a new Reality</h6> :
                        <h6 className = "d-sm-none mt-4 mb-0 min-height-55 padding-bottom-12 ">Experience a new Reality</h6>
                       }
                       
                      </Col>
                      <Col className="text-center" xs="4" sm="4" md="4" onClick = {()=> this.toggleSelect(1)}>
                      {
                         this.state.html_btn_status === 1 ? 
                        <img  alt="" src = {html_btn_2} /> :
                        <img  alt="" src = {html_btn_2_d} />
                      }
                      {
                        this.state.html_btn_status === 1 ? 
                        <h5 className = "d-md-down-none min-height-55 mt-4 mb-0 pb-4 border-bottom border-dark text-dark">Build a new Reality</h5> :
                        <h5 className = "d-md-down-none mt-4 mb-0 pb-4 ">Build a new Reality</h5>
                       }
                       {
                        this.state.html_btn_status === 1 ? 
                        <h6 className = "d-sm-none mt-4  mb-0 pb-4 border-bottom border-dark text-dark">Build a new Reality</h6> :
                        <h6 className = "d-sm-none mt-4 mb-0 pb-4 ">Build a new Reality</h6>
                       }
                      </Col>
                      <Col className="text-center" xs="4" sm="4" md="4"  onClick = {()=> this.toggleSelect(2)}>
                      {
                         this.state.html_btn_status === 2 ? 
                        <img  alt="" src = {html_btn_3} /> :
                        <img  alt="" src = {html_btn_3_d} />
                      }
                      {
                        this.state.html_btn_status === 2 ? 
                        <h5 className = "d-md-down-none min-height-55 mt-4 mb-0 pb-4 border-bottom border-dark text-dark">Craft a Masterpiece</h5> :
                        <h5 className = "d-md-down-none mt-4 mb-0 pb-4 ">Craft a Masterpiece</h5>
                       }
                       {
                        this.state.html_btn_status === 2 ? 
                        <h6 className = "d-sm-none mt-4 mb-0 pb-4 border-bottom border-dark text-dark">Craft a Masterpiece</h6> :
                        <h6 className = "d-sm-none mt-4 mb-0 pb-4 ">Craft a Masterpiece</h6>
                       }
                      </Col>
                    </Row>
                  </Col>
                  <Col md = '3'>
                  </Col>
                </Row>
                <Row className="mt-5">
                  <Col md = '3'>
                  </Col>
                  <Col md = '6'>
                  {
                    this.state.html_btn_status === 0 ?
                    <Row>
                      <Col className="text-center mb-4"  md = '12'>
                        <h4>Use our app to experience the magic of XR</h4>
                      </Col>
                      <Col className="text-center mb-4" md = '12'>
                        <h6>Our app works with all major mobile phones.</h6>
                      </Col>
                      <Col className="text-center mb-1" md = '12'>
                      <Button color="primary" href="https://play.google.com/store/apps/details?id=com.abilitaxr.app" 
                      target="_blank" rel="noopener noreferrer" 
                      className="pr-4 mt-3 mr-3 home-primary-btn pl-4 btn-primary btn-pill" >Download the App</Button>
                      </Col>
                    </Row> : null
                  }
                  {
                    this.state.html_btn_status === 1 ?
                    <Row>
                      <Col className="text-center mb-4"  md = '12'>
                        <h4>Use our platform to build a new reality using immersive technologies.</h4>
                      </Col>
                      <Col className="text-center mb-4" md = '12'>
                        <h6>With our easy to use tools and remarkable templates, you can build it in no time.</h6>
                      </Col>
                      <Col className="text-center mb-1" md = '12'>
                      <Button color="primary" onClick = {()=> this.toggleRegister()} className="pr-4 mt-3 mr-3 pl-4 home-primary-btn btn-primary btn-pill" >Sign up for Free</Button>
                      </Col>
                    </Row> : null
                  }
                  {
                    this.state.html_btn_status === 2 ?
                    <Row>
                      <Col className="text-center mb-4"  md = '12'>
                        <h4>Need our help to create a masterpiece for your business needs?</h4>
                      </Col>
                      <Col className="text-center mb-4" md = '12'>
                        <h6>Contact us and we will do everything to help you. With the ever expanding use cases of XR, every business needs it.</h6>
                      </Col>
                      <Col className="text-center mb-1" md = '12'>
                      <Button color="primary" href="/contact" className="pr-4 mt-3 mr-3 pl-4 home-primary-btn btn-primary btn-pill" >Contact Us</Button>
                      </Col>
                    </Row> : null
                  }
                    
                  </Col>
                  <Col md = '3'>
                  </Col>
                </Row>
                <Row className="mt-5">
                  <img  alt="" src = {bottom_img} className = "d-md-down-none img-width-height-100" />
                  <img  alt="" src = {bottom_img2} className = "d-sm-none img-width-height-100" />
                </Row>
                <Row className="pt-5 pb-5 home-background-gray">
                  <Col xs="0" sm="0" lg="1">
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "ml-2 text-left">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>PRODUCT</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                         <a href = "/feature"><div className = "font-size-10" >Features</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/appguide"><div className = "font-size-10" >App Guide</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Platform Guide</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "/customdev"><div className = "font-size-10" >Custom Development</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <div className = "font-size-10" >Pricing</div>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://goo.gl/1s6PZH" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Get VR Headset</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div >USE CASES</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/realestate"><div className = "font-size-10" >Real Estate</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/architecture"><div className = "font-size-10" >Architecture</div></a>
                      </Col>
                      <Col className = "mb-2  text-secondary" md = '12'> 
                        <a href = "/medical"><div className = "font-size-10" >Medical</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/retail"><div className = "font-size-10" >Retail</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/sports"><div className = "font-size-10" >Sports</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/media"><div className = "font-size-10" >Media</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/travel"><div className = "font-size-10" >Travel</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/education"><div className = "font-size-10" >Education</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/training"><div className = "font-size-10" >Training</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/ecommerce"><div className = "font-size-10" >Ecommerce</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/entertainment"><div className = "font-size-10" >Entertainment</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4" sm="4" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>Support</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "http://www.icomputinglabs.in/blog/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" >Blog</div> </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/faq"><div className = "font-size-10" >FAQ</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/contact"><div className = "font-size-10" >Contact</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>COMPANY</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/about"><div className = "font-size-10" >About</div></a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "/privacy"><div className = "font-size-10" >Privacy Policy</div></a>
                      </Col>
                      <Col className = "mb-2 text-secondary" md = '12'> 
                        <a href = "/tos"><div className = "font-size-10" >Terms of Service</div></a>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="6" sm="6" lg="2">
                    <Row className = "text-left ml-2">
                      <Col className="mt-5 mb-4" md = '12'> 
                        <div>GET CONNECTED</div>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.facebook.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-facebook-square fa-lg mr-2" />facebook</div>
                        </a>
                      </Col>
                      <Col className="mb-2 text-secondary" md = '12'> 
                        <a href = "https://www.instagram.com/icomputinglabs/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><img  alt="" src={instagram_square} className = "text-primary width-16 mr-2" />instagram</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'> 
                        <a href = "https://twitter.com/iComputingLabs" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-twitter-square fa-lg mr-2" />twitter</div>
                        </a>
                      </Col>
                      <Col className = "mb-2 text-secondary"  md = '12'>
                        <a href = "https://www.linkedin.com/company/13404850/" target="_blank" rel="noopener noreferrer">
                        <div className = "font-size-10" ><i className = "text-primary fa fa-linkedin-square fa-lg mr-2" />linkedin</div>
                        </a>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
        </div>
        <Modal isOpen={this.state.watchDemo} toggle={this.toggleWatchDemo}
                  className={' modal-primary ' + this.props.className}>
          <ModalBody>
            <Row>
            <Col xs="12" md='12' sm="12" lg="12">
              {/* <iframe title="This is a unique title" className ="d-md-down-none read-more-100" src="https://youtu.be/_tsWNs-pErQ" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> */}
              <iframe className ="d-md-down-none read-more-100" src="https://www.youtube.com/embed/_tsWNs-pErQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <iframe className ="d-sm-none read-more-100-mobile" src="https://www.youtube.com/embed/_tsWNs-pErQ" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </Col>
            </Row>
          </ModalBody>
        </Modal>
        </React.Fragment>
      </div>
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/views/Pages/Landing/Landing.js